import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthGlobal } from "../types/auth";

const initialState: AuthGlobal = {
  userEmail: "",
  userRole: "",
  userKey: "",
  userToken: "",
  currentUser: null,
  isMasterVendor: false,
  lanMandatory: false,
  masterVendorName: "",
  everestPartner: false,
  lanLength: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setGlobalUserData: (state, action: PayloadAction<any>) => {
      return { ...state, ...action.payload };
    },
    clearAuth: () => {
      return {
        userEmail: "",
        userRole: "",
        userKey: "",
        userToken: "",
        currentUser: null,
        isMasterVendor: false,
        lanMandatory: false,
        masterVendorName: "",
        everestPartner: false,
        lanLength: null,
      };
    },
  },
});

export const { setGlobalUserData, clearAuth } = authSlice.actions;

export default authSlice.reducer;
